module.exports = __webpack_public_path__ + "img/knee.d3c693b5.png";